<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-resize="onResize"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Create Payment Request</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSend"
                >
                    {{ok_label}}
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px"
        >
            <v-alert
                v-model="show_error_message"
                type="error"
                color="primary"
                v-if="error_message != null"
                dismissible
            >
                {{error_message}}
            </v-alert>

           <div
            style="width: 100%; display: flex; flex-direction: row; padding-top: 15px;"
           >
                <div
                    :style="style_left_pane"
                >
                    <fieldset
                        style="padding: 15px; border-radius: 5px; margin-bottom: 15px; position: relative; top: -10px"
                    >
                        <legend style="padding-left: 5px; padding-right: 5px;">Internal use only</legend>
                        <v-text-field
                            v-if="show_created_for"
                            label="Name"
                            v-model="created_for"
                            hint="The name of the person that this payment request is being created for"
                            :autofocus="show_created_for"
                            v-on:input="updatePreview"
                            autocomplete="off"
                        />
                        
                        <v-text-field
                            label="Internal Label"
                            v-model="label"
                            hint="The internal label should help you identify the transaction in the future.  Visible to RedChirp users only."
                            :autofocus="!show_created_for"
                            v-on:input="updatePreview"
                            autocomplete="off"
                            ref="internal-label"
                        />

                    </fieldset>

                    <fieldset
                        style="padding: 15px; border-radius: 5px; margin-bottom: 15px;"
                    >
                        <legend style="padding-left: 5px; padding-right: 5px;">For the customer</legend>

                        
                    <v-select
                        v-if="show_banner_branding_select"
                        label="Branding"
                        :items="banner_branding_items"
                        v-model="banner_id"
                        v-on:change="doUpdatePreview"
                    />

                    <v-textarea
                        label="Item Description (optional)"
                        v-model="description"
                        hint="Describes the transaction to the customer."
                        :rows="1"
                        auto-grow
                        v-on:input="updatePreview"
                    >
                        <span
                            slot="append-outer"
                        >
                            <v-icon
                                style="align-self: flex-end; margin-bottom: 3px; margin-right: 2px"
                                v-on:click="onClickSearchPreviousDescriptions"
                            >
                                mdi-magnify
                            </v-icon>
                        </span>
                    </v-textarea>

                    <v-text-field
                            label="Invoice # (optional)"
                            hint="The invoice number is visible to your customer when they enter their payment information."
                            v-model="invoice_number"
                            v-on:input="updatePreview"
                            autocomplete="off"
                        />

                    

                    <v-radio-group
                        v-model="payment_type"
                        row
                        v-on:input="doUpdatePreview"
                        style="margin-bottom: -10px; margin-top: -5px"
                    >
                        <v-radio
                            label="One Time Payment"
                            value="one_time_payment"
                        />
                        <v-radio
                            label="Subscription"
                            value="subscription"
                        />
                    </v-radio-group>

                    <m-edit-monetary-amount
                        v-if="payment_type == 'one_time_payment'"
                        label="Amount"
                        v-model="amount"
                        v-on:input="updatePreview"
                        autocomplete="off"
                        ref="amount"
                    />

                    <v-text-field
                        v-if="payment_type == 'subscription'"
                        label="Purpose"
                        v-model="for_message"
                        hint="That is, why are you asking them for their credit card (e.g. &quot;Place a card on file&quot;, &quot;Monthly fee&quot;, etc.)"
                        v-on:input="updatePreview"
                        persistent-hint
                        style="margin-bottom: 20px; margin-top: -10px;"
                        ref="purpose"
                    />

                    <v-select
                        label="Address Information"
                        :items="$rc.enumChoices('payment_address_info_request',false)"
                        v-model="amount_of_address_information"
                        return-object
                        v-on:change="doUpdatePreview"
                    />

                    <v-select
                        label="Email Address"
                        :items="$rc.enumChoices('payment_request_ex_field_display_state', false)"
                        v-model="ex_field_email"
                        v-on:change="doUpdatePreview"
                    />

                    <v-select
                        label="Phone Number"
                        :items="$rc.enumChoices('payment_request_ex_field_display_state', false)"
                        v-model="ex_field_phone"
                        v-on:change="doUpdatePreview"
                    />

                    <v-select
                        label="Age Verification"
                        :items="$rc.enumChoices('age_verification_requirement',false)"
                        v-model="age_verification_requirement"
                        hint="Require a verification method to ensure the recipient is at least a minimum age"
                        persistent-hint
                        v-on:change="onChangeAgeVerification"
                    />

                    <v-text-field
                        v-show="age_verification_requirement != 'none'"
                        label="Minimum Age (Years)"
                        v-model="min_age_in_years"
                        v-on:input="updatePreview"
                        autocomplete="off"
                    />

                    </fieldset>

                    <div
                        style="text-align: right"
                    >
                        <v-btn
                           style="margin-right: 15px"
                           @click="onClickDiscardChanges"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                           color="primary"
                           @click="onClickSend"
                        >
                            Send Payment Request
                        </v-btn>

                    </div>
                </div>
                <div
                    style="border: 2px solid rgba(0,0,0,0.4); flex-grow: 2; letter-spacing: normal; line-height: 45px; overflow-wrap:normal; position: relative;"
                    v-if="show_preview"
                >
                    <m-make-payment-content
                        v-if="preview_payment != null"
                        :payment="preview_payment"
                        :banner_branding="preview_payment.banner_branding"
                        :payment_not_found="false"
                        :stage="3"
                        preview
                    />
                </div>
           </div>


           

        </v-card-text>

    </v-card>

    <m-search-payment-descriptions-dialog
        ref="search_payment_descriptions_dialog"
        v-on:input="onSetDescription"
    />
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        ok_label: {
            type: String,
            default: function() { return 'Send Payment Request'; }
        },

        show_created_for: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            dialog: false,

            label: null,
            invoice_number: null,
            amount: 'USD0.00',
            for_message: null,
            payment_type: 'one_time_payment',
            min_age_in_years: 21,
            description: null,
            banner_branding: [],
            banner_id: null,
            created_for: null,
            preview_payment: null,
            ex_field_email: 'do-not-show',
            ex_field_phone: 'do-not-show',
            error_message: null,
            show_error_message: false,

            show_preview: false,

            amount_of_address_information: { 'text' : 'Billing Zip / Postal Code', 'value' : 'billing-zip-code' },

            age_verification_requirement: 'none',
        }
    },

    methods: {

        showDialog()
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'GET: /api/v1/organizations/payment-settings/:organization_id',
            
                {
                    'organization_id' : this.$rc.$state.getOrganizationId(),
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.label = null;
                    this.invoice_number = null;
                    this.amount = data.default_currency+'0.00';
                    this.for_message = null;
                    this.show_error_message = false;
                    this.payment_type = 'one_time_payment';
                    this.amount_of_address_information = { 'text' : 'Billing Zip / Postal Code', 'value' : 'billing-zip-code' };
                    this.age_verification_requirement = data.default_age_verification_requirement;
                    this.min_age_in_years = data.default_min_age_in_years;
                    this.description = null;
                    this.banner_branding = data.banner_branding;
                    this.ex_field_email = 'do-not-show';
                    this.ex_field_phone = 'do-not-show';

                    this.banner_id = null;

                    for ( let i = 0; i < this.banner_branding.length; i++ )
                    {
                        let item = this.banner_branding[i];
                        if ( item.is_default )
                            this.banner_id = item.banner_id;
                    }

                    this.dialog = true;
                    this.$router.dialog_guard = this.dialogGuard;

                    this.doUpdatePreview();
                    this.onResize();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = true;
            next(false);
        },

        onResize()
        {
            let sp = window.innerWidth >= 960;
            
            if ( sp != this.show_preview )
            {
                this.show_preview = sp;
                this.$forceUpdate();
            }
        },

        createPaymentPostData()
        {
            let for_message = this.for_message;

            if (this.payment_type == 'one_time_payment')
            {
                for_message = null;
            }


            return {
                'label' : this.label,
                'invoice_number' : this.invoice_number,
                'amount' : this.amount,
                'for_message' : for_message,
                'amount_of_address_information' : this.amount_of_address_information.value,
                'age_verification_requirement' : this.age_verification_requirement,
                'min_age_in_years' : this.min_age_in_years,
                'description': this.description,
                'banner_id' : this.banner_id,
                'created_for' : this.created_for,
                'ex_field_email': this.ex_field_email,
                'ex_field_phone': this.ex_field_phone,
            };
        },

        updatePreview: _.debounce(function(){
            this.doUpdatePreview();
        }, 751),
        
        doUpdatePreview()
        {
            let post_data = this.createPaymentPostData();

            this.$rc.rest(
                'PREVIEW: /api/v1/payments/create-payment-request',
            
                post_data,
            
                (data) => {
                    this.preview_payment = data;
                },
            
                () => {
                },
            );
        },
        

        onClickSend()
        {
            // Validate!
            {
                if ( this.label == null || this.label.trim().length == 0 )
                {
                    this.$refs['internal-label'].focus();
                    this.error_message = 'An internal label is required';
                    this.show_error_message = true;
                    return;
                }

                if ( this.payment_type == 'subscription' )
                {
                    if ( this.for_message == null || this.for_message.trim() == '' )
                    {
                        this.$refs['purpose'].focus();
                        this.error_message = 'A purpose is required';
                        this.show_error_message = true;
                        return;
                    }
                }

                if ( this.payment_type == 'one_time_payment' && this.amount != null )
                {
                    if ( this.amount == 'USD0.00' || this.amount == 'CAD0.00' )
                    {
                        this.$refs['amount'].focus();
                        this.error_message = 'A non-zero amount is required for one-time payments';
                        this.show_error_message = true;
                        return;
                    }
                }

                if ( this.age_verification_requirement != 'none' )
                {
                    let min_age_in_years_int = parseInt(this.min_age_in_years);

                    if ( isNaN(min_age_in_years_int) || min_age_in_years_int <= 0 || min_age_in_years_int > 90 )
                    {
                        this.error_message = 'A minimum age in years is required (must be larger than zero and less than 90)';
                        this.show_error_message = true;
                        return;
                    }
                }

                // TODO: Check for USD0.00 payment requests in one-time-payment mode to prevent mistakes...
            }

            this.dialog = false;

            this.$emit('ok',this.createPaymentPostData());
            
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onCancel()
        {
            this.dialog = false;
        },

        onChangeAgeVerification(value)
        {
            // Auto-populate with organization default when enabling age verification
            if (value !== 'none') {
                this.min_age_in_years = this.organization_default_age_gate_age;
            }
            this.doUpdatePreview();
        },

        onClickSearchPreviousDescriptions()
        {
            this.$refs['search_payment_descriptions_dialog'].showDialog();
        },

        onSetDescription(value)
        {
            this.description = value;
        },
    },

    computed: {
        show_banner_branding_select() {
            return this.banner_branding.length > 1;
        },

        banner_branding_items() {
            let ret = [];

            for ( let i = 0; i < this.banner_branding.length; i++ )
            {
                let item = this.banner_branding[i];

                ret.push({
                    'text': item.internal_label,
                    'value': item.banner_id,
                });
            }

            return ret;
        },

        style_left_pane() 
        {
            if ( this.show_preview )
            {
                return "flex-grow: 1; margin-right: 30px; max-width: 600px";
            }

            return "flex-grow: 1; margin-right: 30px;";
            
        },

        organization_default_age_gate_age()
        {
            if ( this.$rc.$state.profile == null ) return 21;
            if ( this.$rc.$state.profile.organization_account == null ) return 21;
            if ( this.$rc.$state.profile.organization_account.features == null ) return 21;
            return this.$rc.$state.profile.organization_account.features.default_age_gate_age || 21;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>